import axios from "axios";
import dayjs from "dayjs";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {SET_SNACKBAR} from "../../constants";
import React from "react";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";

export const useExportRepository = () => {

    const {dispatchGlobalData} = React.useContext(GlobalContext);

    const PATH = "/pricing/rate-detail/export";

    function getExport(productCode: string, pickupPeriodFrom: string, pickupPeriodTo: string) {
        return axios.get(`${PATH}/rate-increment?productCode=${productCode}&pickupPeriodFrom=${pickupPeriodFrom}&pickupPeriodTo=${pickupPeriodTo}`, {
            headers: {
                'Content-type': 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet'
            },
            responseType: 'blob',
        })
            .then(({data}) => {
                const blob = new Blob([data], {
                    type: `application/${'vnd.openxmlformatsofficedocument.spreadsheetml.sheet'}`,
                });

                const url = window.URL.createObjectURL(blob); // creiamo l'url al Blob
                const a = document.createElement('a'); // creiamo un elemento nel DOM
                const title = `export_rate_si_${dayjs().format("YYYYMMDDHHmm")}_.xlsx`; // creiamo il titolo per il file

                a.href = url; // appendiamo l'url del Blob all'elemento creato
                a.download = `${title}`; // appendiamo la proprietà di download con nome ed estension del file
                a.click(); // aggiungiamo il click event per procedere al download

            })

            .catch(async error => {

                let parsedError = JSON.parse(await error.response.data.text())
                let parsed = JSON.parse(await parsedError.errorDetails)
                if (await parsed) {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: parsed.reportedErrors,
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true
                            }
                        }
                    });
                } else {
                    dispatchGlobalData(SET_SNACKBAR.ERROR);
                }
                return Promise.reject(error);
            })
    }

    return {
        getExport
    };
};
